@if (canAssignJob || assignedChips.length > 0) {
  <div
    class="restock-assign-job"
    [class.restock-assign-open]="showJobSelect"
    (click)="$event.stopPropagation()">
    <tidy-row
      [alignLastItemRight]="canAssignJob"
      class="vertical-align-center extra-bottom-padding">
      <tidy-text
        [header]="'Restocking Jobs'" />
      @if (canAssignJob) {
        <tidy-small-button
          [text]="showJobSelect ? 'Close' : 'Assign to Job'"
          [image]="showJobSelect ? 'assets/svg/close-outline.svg' : 'assets/svg/calendar-outline.svg'"
          class="compact"
          (buttonClick)="toggleJobSelect($event)" />
      }
    </tidy-row>

    @if (assignedChips.length > 0) {
      <tidy-row class="restock-assigned-chips">
        @for (chip of assignedChips; track chip.bookingId) {
          <span class="restock-job-chip">
            <tidy-image
              [src]="chip.icon"
              class="restock-job-chip-icon" />
            <span class="restock-job-chip-label">{{ chip.label }}</span>
            @if (chip.proInitials) {
              <span class="restock-job-chip-initials">{{ chip.proInitials }}</span>
            }
            @if (chip.removable) {
              <span
                class="restock-job-chip-remove"
                (click)="unassignJob(chip.bookingId, $event)"></span>
            }
          </span>
        }
      </tidy-row>
    } @else if (canAssignJob) {
      <tidy-row>
        <tidy-text
          [helper]="'Not assigned to a job yet.'" />
      </tidy-row>
    }

    @if (showJobSelect) {
      <div class="restock-job-backdrop" (click)="cancelJobSelect($event)"></div>
      <div class="restock-job-dropdown" (click)="$event.stopPropagation()">
        <div class="restock-job-search">
          <tidy-image
            [src]="'assets/svg/search-outline.svg'"
            class="restock-job-search-icon" />
          <input
            class="restock-job-search-input"
            type="text"
            [placeholder]="'Search jobs' | translate"
            [ngModel]="jobSearch"
            (ngModelChange)="onJobSearch($event)"
            (click)="$event.stopPropagation()" />
        </div>

        @if (!jobItemsLoaded) {
          <div class="restock-job-empty">
            <tidy-text [helper]="'Loading jobs…'" />
          </div>
        } @else if (filteredJobItems.length === 0) {
          <div class="restock-job-empty">
            <tidy-text
              [helper]="jobItems.length === 0 ? 'No upcoming jobs for this property.' : 'No matching jobs.'" />
          </div>
        } @else {
          <div class="restock-job-list">
            @for (item of filteredJobItems; track item.bookingId) {
              <div
                class="restock-job-option"
                (click)="onJobSelected(item.bookingId, $event)">
                <tidy-image
                  [src]="item.icon"
                  class="restock-job-option-icon" />
                <div class="restock-job-option-main">
                  <span class="restock-job-option-label">{{ item.label }}</span>
                  @if (item.statusLabel) {
                    <span class="restock-job-option-status">{{ item.statusLabel }}</span>
                  }
                </div>
                @if (item.proInitials) {
                  <span class="restock-job-option-initials">{{ item.proInitials }}</span>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
